import LayerStarter from "../image/Layer starter.png"
import LayerGrowers from "../image/layer grower.png"
import PreLayerFeed from "../image/pre-layer feed.png"
import LayerFeed from "../image/layer feed.png"
import BroilerStarterCrumble from "../image/broiler starter-crumble.png"
import BroilerStarterPellets from "../image/broiler starter.png"
import BroilerFinisher from "../image/broiler finisher.png"
import PigStarter from "../image/pig start.png"
import PigFinisher from "../image/pig finisher.png"
import Pregnant from "../image/pregnant sow meal.png"
import Lactating from "../image/lactating saw meal.png"
import Dairy from "../image/dairy meal.png"
import Maize from '../image/maize.png'
import Bran from '../image/ricebran.png'
import Broken from '../image/broken rice.png'
import MaizeBran from '../image/maize bran.png';
import Cassava from '../image/raw cassava.png';
import Soybean from '../image/Soyabean-Meal.png';

export const products = [
    {
      image: LayerStarter,
      title: "Layer Starter",
      description: "Layer Starter feed is specially designed to nourish young hens, ensuring healthy growth and optimal egg production.",
      altText: "Layer Starter feed for healthy chicken growth"
    },
    {
      image: LayerGrowers,
      title: "Layer Grower",
      description: "Layer Grower feed supports the transition of hens to their laying phase, promoting stronger eggs and improved production.",
      altText: "Layer Grower feed for transitioning hens"
    },
    {
      image: PreLayerFeed,
      title: "Pre-Layer Feed",
      description: "Pre-Layer Feed helps hens prepare for the laying stage, ensuring optimal health and egg development.",
      altText: "Pre-Layer Feed for hen preparation"
    },
    {
      image: LayerFeed,
      title: "Layer Feed",
      description: "Layer Feed provides the essential nutrients to laying hens, enhancing egg quality and productivity.",
      altText: "Layer Feed for healthy egg production"
    },
    {
      image: BroilerStarterCrumble,
      title: "Broiler Starter Crumble",
      description: "Broiler Starter Crumble is formulated for young broilers, promoting rapid growth and efficient weight gain.",
      altText: "Broiler Starter Crumble feed for fast growth"
    },
    {
      image: BroilerStarterPellets,
      title: "Broiler Starter Pellets",
      description: "Broiler Starter Pellets support early development in broilers, helping them achieve optimal weight gain quickly.",
      altText: "Broiler Starter Pellets for rapid growth"
    },
    {
      image: BroilerFinisher,
      title: "Broiler Finisher Pellets",
      description: "Broiler Finisher Pellets are designed to ensure the best finish in broilers, enhancing meat quality and size.",
      altText: "Broiler Finisher Pellets for superior meat quality"
    },
    {
      image: PigStarter,
      title: "Pig Starter Feed",
      description: "Pig Starter Feed ensures optimal growth for piglets, providing balanced nutrition for their early stages.",
      altText: "Pig Starter Feed for healthy piglet growth"
    },
    {
      image: PigFinisher,
      title: "Pig Finisher Feed",
      description: "Pig Finisher Feed supports pigs during the finishing phase, helping them achieve ideal market weight.",
      altText: "Pig Finisher Feed for market-ready pigs"
    },
    {
      image: Pregnant,
      title: "Pregnant Sow Meal",
      description: "Pregnant Sow Meal provides necessary nutrients for sows during pregnancy, supporting healthy birth rates.",
      altText: "Pregnant Sow Meal for healthy pregnancies"
    },
    {
      image: Lactating,
      title: "Lactating Sow Meal ",
      description: "Lactating Sow Meal supports sows during lactation, ensuring sufficient milk production for piglets.",
      altText: "Lactating Sow Meal for milk production"
    },
    {
      image: Dairy,
      title: "Dairy Meal",
      description: "Dairy Meal is formulated for optimal milk production, enhancing the health and yield of dairy cattle.",
      altText: "Dairy Meal for high milk yield"
    },
  ];
  
  export const rawMaterials = [
    {
      image: Maize,
      title: "Whole Maize",
      description: "Whole Maize is a nutritious raw material for animal feed, providing a high-energy source for livestock.",
      altText: "Whole Maize for animal feed"
    },
    {
      image: Bran,
      title: "Rice Bran",
      description: "Rice Bran is a by-product of rice milling, rich in nutrients like fiber, protein, and essential fatty acids.",
      altText: "Rice Bran as a raw material for feed"
    },
    {
      image: Broken,
      title: "Broken Rice",
      description: "Broken Rice serves as an affordable and nutritious ingredient in animal feed, providing essential carbohydrates.",
      altText: "Broken Rice as a feed ingredient"
    },
    {
      image: MaizeBran,
      title: "Maize Bran",
      description: "Maize Bran is a high-protein, high-fiber ingredient for animal feed, supporting growth and digestion.",
      altText: "Maize Bran for livestock feed"
    },
    {
      image: Cassava,
      title: "Raw Cassava",
      description: "Raw Cassava is a versatile raw material used in animal feed, providing a rich source of starch and energy.",
      altText: "Raw Cassava for animal feed energy"
    },
    {
      image: Soybean,
      title: "Soybean Meal",
      description: "Soybean Meal is a high-protein by-product of soybean processing, providing essential amino acids for livestock growth.",
      altText: "Soybean Meal for protein-rich animal feed"
    },
  ];
